import React from "react";
import styles from "./style.module.css";

export const HamburgerIcon = ({ expanded }) => {
  return (
    <div className={`${styles.hamburger} ${expanded ? styles.open : ""}`}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
